import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "map",
  style: {"margin":"0 !important"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  style: {"width":"100%","min-height":"inherit","height":"inherit"}
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "bubble-desc"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  src: "https://www.location-gardemeuble.fr/img/no-img.gif",
  alt: "Aucune image disponible pour ce garde-meuble"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { style: {"font-size":"0.9em"} }
const _hoisted_8 = {
  key: 0,
  class: "stars",
  style: {"font-size":"1.5em","margin-top":"-0.4em"}
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { style: {"font-size":"1.1em"} }
const _hoisted_11 = { class: "grey" }
const _hoisted_12 = { style: {"font-size":"0.6em","padding":"0","text-align":"center","margin":"auto"} }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_Transition, {
      mode: "out-in",
      name: "fade"
    }, {
      default: _withCtx(() => [
        (this.map_gm >= 0 && this.store.state.search !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (typeof this.store.state.search.near[this.map_gm].images[0] !== 'undefined')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: this.store.state.search.near[this.map_gm].images[0].url,
                    alt: this.store.state.search.near[this.map_gm].images[0].title
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              (typeof this.store.state.search.near[this.map_gm].images[0] === 'undefined')
                ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("b", null, _toDisplayString(this.store.state.search.near[this.map_gm].name), 1),
                  _hoisted_6,
                  _createElementVNode("i", _hoisted_7, _toDisplayString(this.store.state.search.near[this.map_gm].keyword), 1),
                  (this.store.state.search.near[this.map_gm].avis.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("a", {
                          href: this.store.state.search.near[this.map_gm].url + '#avis',
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.store.state.counter( 'avis', _ctx.gm.id, () => '' )))
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                                return _createVNode(_component_font_awesome_icon, { icon: "star" })
                              }), 64))
                            ]),
                            _createElementVNode("div", {
                              class: "gold",
                              style: _normalizeStyle({ width : ( this.store.state.search.near[this.map_gm].note / 5 * 100 ) + '%' })
                            }, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                                return _createVNode(_component_font_awesome_icon, { icon: "star" })
                              }), 64))
                            ], 4)
                          ]),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(this.store.state.search.near[this.map_gm].note.toFixed( 1 )) + " / 5.0 étoiles basées sur " + _toDisplayString(this.store.state.search.near[this.map_gm].avis.length) + " avis ", 1)
                        ], 8, _hoisted_9)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("a", {
                href: this.store.state.search.near[this.map_gm].url,
                rel: "nofollow",
                class: "button"
              }, " Voir plus ", 8, _hoisted_13)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}